/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.85
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  PagePamPlayerSearchSummary,
  PlayerCapabilities,
  PlayerDetailsEditRequest,
  PlayerWithPAMDetails,
} from '../models/index';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    PagePamPlayerSearchSummaryFromJSON,
    PagePamPlayerSearchSummaryToJSON,
    PlayerCapabilitiesFromJSON,
    PlayerCapabilitiesToJSON,
    PlayerDetailsEditRequestFromJSON,
    PlayerDetailsEditRequestToJSON,
    PlayerWithPAMDetailsFromJSON,
    PlayerWithPAMDetailsToJSON,
} from '../models/index';

export interface GetPlayerByLookupRequest {
    playerLookupId: string;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface GetPlayerCapabilitiesRequest {
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface SearchPlayersRequest {
    search: string;
    resultStart: number;
    resultEnd: number;
    customerId: string;
    xClientID?: string;
    xRequestID?: string;
}

export interface UpdatePlayerDetailsRequest {
    playerLookupId: string;
    customerId: string;
    playerDetailsEditRequest: PlayerDetailsEditRequest;
    xClientID?: string;
    xRequestID?: string;
}

/**
 * 
 */
export class PlayersApi extends runtime.BaseAPI {

    /**
     * Get a player by their lookup ID
     */
    async getPlayerByLookupRaw(requestParameters: GetPlayerByLookupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerWithPAMDetails>> {
        if (requestParameters['playerLookupId'] == null) {
            throw new runtime.RequiredError(
                'playerLookupId',
                'Required parameter "playerLookupId" was null or undefined when calling getPlayerByLookup().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPlayerByLookup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:player-details"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/players/{playerLookupId}`;
        urlPath = urlPath.replace(`{${"playerLookupId"}}`, encodeURIComponent(String(requestParameters['playerLookupId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerWithPAMDetailsFromJSON(jsonValue));
    }

    /**
     * Get a player by their lookup ID
     */
    async getPlayerByLookup(requestParameters: GetPlayerByLookupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerWithPAMDetails> {
        const response = await this.getPlayerByLookupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Players-area capabilities for the customer (e.g. whether players are locally managed).
     */
    async getPlayerCapabilitiesRaw(requestParameters: GetPlayerCapabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerCapabilities>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling getPlayerCapabilities().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:player-details"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/player-capabilities`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerCapabilitiesFromJSON(jsonValue));
    }

    /**
     * Players-area capabilities for the customer (e.g. whether players are locally managed).
     */
    async getPlayerCapabilities(requestParameters: GetPlayerCapabilitiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerCapabilities> {
        const response = await this.getPlayerCapabilitiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Search PAM players by name or email (substring) or exact lookup id.
     */
    async searchPlayersRaw(requestParameters: SearchPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagePamPlayerSearchSummary>> {
        if (requestParameters['search'] == null) {
            throw new runtime.RequiredError(
                'search',
                'Required parameter "search" was null or undefined when calling searchPlayers().'
            );
        }

        if (requestParameters['resultStart'] == null) {
            throw new runtime.RequiredError(
                'resultStart',
                'Required parameter "resultStart" was null or undefined when calling searchPlayers().'
            );
        }

        if (requestParameters['resultEnd'] == null) {
            throw new runtime.RequiredError(
                'resultEnd',
                'Required parameter "resultEnd" was null or undefined when calling searchPlayers().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling searchPlayers().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['resultStart'] != null) {
            queryParameters['resultStart'] = requestParameters['resultStart'];
        }

        if (requestParameters['resultEnd'] != null) {
            queryParameters['resultEnd'] = requestParameters['resultEnd'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:player-details"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/players`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagePamPlayerSearchSummaryFromJSON(jsonValue));
    }

    /**
     * Search PAM players by name or email (substring) or exact lookup id.
     */
    async searchPlayers(requestParameters: SearchPlayersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagePamPlayerSearchSummary> {
        const response = await this.searchPlayersRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Edit a locally-managed (PAM) player\'s name, email, phone, address, dob, and/or ssn4 fields. Editing ssn4 additionally requires the write:player-ssn scope.
     */
    async updatePlayerDetailsRaw(requestParameters: UpdatePlayerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlayerWithPAMDetails>> {
        if (requestParameters['playerLookupId'] == null) {
            throw new runtime.RequiredError(
                'playerLookupId',
                'Required parameter "playerLookupId" was null or undefined when calling updatePlayerDetails().'
            );
        }

        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling updatePlayerDetails().'
            );
        }

        if (requestParameters['playerDetailsEditRequest'] == null) {
            throw new runtime.RequiredError(
                'playerDetailsEditRequest',
                'Required parameter "playerDetailsEditRequest" was null or undefined when calling updatePlayerDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xClientID'] != null) {
            headerParameters['X-Client-ID'] = String(requestParameters['xClientID']);
        }

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:player-details"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/players/{playerLookupId}/details`;
        urlPath = urlPath.replace(`{${"playerLookupId"}}`, encodeURIComponent(String(requestParameters['playerLookupId'])));
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PlayerDetailsEditRequestToJSON(requestParameters['playerDetailsEditRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlayerWithPAMDetailsFromJSON(jsonValue));
    }

    /**
     * Edit a locally-managed (PAM) player\'s name, email, phone, address, dob, and/or ssn4 fields. Editing ssn4 additionally requires the write:player-ssn scope.
     */
    async updatePlayerDetails(requestParameters: UpdatePlayerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlayerWithPAMDetails> {
        const response = await this.updatePlayerDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
